import { deriveBorrowerBuyer, deriveSellers, IClientOrderData } from 'types/clientPortal/IClientOrderData';
import { convertIPropertyAddressDataToIPropertyAddress } from 'types/clientPortal/ISignatory';
import { getOrderInformation } from './getOrderInformation';
import { newGetTransaction } from './getTransaction';
import { eExternalOrderStatus } from '../../ui-toolkit/enums/eExternalOrderStatus';
import { createDefaultProperty } from '../../ui-toolkit/orders/interfaces/IPropertyAddress';
import { IOrderDetailsData } from '../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export const determineOrderDetailsData = ({ order }: { order?: IClientOrderData }): IOrderDetailsData => {
  const borrowerBuyer = order ? deriveBorrowerBuyer(order) : [];
  const seller = order ? deriveSellers(order) : [];

  return {
    transaction: newGetTransaction(order),
    property: order ? convertIPropertyAddressDataToIPropertyAddress(order.propertyAddress) : createDefaultProperty(),
    lender: {
      id: order?.lenderCompany?.id || '',
      name: order?.lenderCompany?.name || '',
      mortgageeClause: '',
      bulkRateQualified: null,
    },
    orderInformation: getOrderInformation(order ? order.orderStatus : eExternalOrderStatus.new),
    client: {
      id: '',
      name: '',
      sprucePowered: false,
    },
    parties: [...borrowerBuyer, ...seller],
  };
};
